import { render, staticRenderFns } from "./dropdown-button.vue?vue&type=template&id=53141b5d&scoped=true"
import script from "./dropdown-button.vue?vue&type=script&lang=js"
export * from "./dropdown-button.vue?vue&type=script&lang=js"
import style0 from "./dropdown-button.vue?vue&type=style&index=0&id=53141b5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53141b5d",
  null
  
)

export default component.exports